import React from "react";

import { TbMailOpened } from '../assets/icons/icons'

export default function FooterTopThree(){
    return(
        <section className="section p-0">
        <div className="container-fluid px-0">
            <div className="py-5 bg-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <div className="section-title">
                                <div className="d-flex">
                                    <TbMailOpened className="display-4 text-white title-dark"/>
                                    <div className="flex-1 ms-md-4 ms-3">
                                        <h4 className="fw-bold text-light title-dark mb-1">Subscribe to our newsletters</h4>
                                        <p className="text-white-50 mb-0">Sign up and receive the latest tips via email.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-4 mt-sm-0">
                            <div className="text-md-end ms-5 ms-sm-0">
                                <form>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="mb-3">
                                                <input type="email" name="email" id="emailsubscribe" className="form-control rounded bg-soft-light" placeholder="Your email : " required/>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="d-grid">
                                                <input type="submit" id="submitsubscribe" name="send" className="btn btn-primary" value="Subscribe"/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}